import { Controller } from 'react-hook-form';
import { formatDate, InputText } from '@ui/src';
import { DictionaryItemFormTypes } from './types';

import cn from './styles.module.css';

const DictionaryItemForm = ({
  control,
  errors,
  setValue,
  isEditable,
  deletedAt,
}: DictionaryItemFormTypes) => (
  <>
    {deletedAt && (
      <div className={cn.deleted}>
        Dictionary value deleted {formatDate(deletedAt, true)}
      </div>
    )}
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="value"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            value={value}
            title="Value"
            placeholder="Enter Value"
            onChange={(e) => {
              onChange(e.target.value);

              const codeValue = e.target.value
                .split(' ')
                ?.map((item) => item.toUpperCase())
                .join('_');

              setValue('code', codeValue);
            }}
            error={errors?.value?.message}
            disabled={!isEditable}
          />
        )}
      />
    </div>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="code"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            value={value as string}
            title="Code (optional)"
            placeholder="Enter Code"
            onChange={onChange}
            error={errors?.code?.message}
            disabled={!isEditable}
          />
        )}
      />
    </div>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="riskScore"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            value={value}
            title="Risk Score"
            placeholder="Enter Risk Score"
            onChange={(e) => {
              let formattedValue = e.target.value.replace(/\D/g, '');

              if (Number(formattedValue) < 0) {
                formattedValue = '0';
              } else if (Number(e.target.value) > 100) {
                formattedValue = '100';
              }

              onChange(formattedValue);
            }}
            error={errors?.riskScore?.message}
            disabled={!isEditable}
          />
        )}
      />
    </div>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="description"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            value={value as string}
            title="Description (optional)"
            placeholder="Enter Description"
            onChange={onChange}
            error={errors?.description?.message}
            disabled={!isEditable}
          />
        )}
      />
    </div>
  </>
);

export default DictionaryItemForm;
